









































import { computed, defineComponent } from "@vue/composition-api";

import { Document } from "@/tools/msa/models";

interface Props {
  document: Document;
}

export default defineComponent<Props>({
  name: "ExportedDocument",
  props: {
    document: { type: Object, required: true }
  },
  setup(props: Props) {
    const sections = computed(() =>
      props.document.pages
        .flatMap(page => page.sections)
        .filter(section => section.included)
        .map(section =>
          section.tokens
            .map(token => `${token.text}${token.delimiter}`)
            .join("")
            .replaceAll("\n", "<br>")
        )
    );

    return { sections };
  }
});
